import { createAction } from 'redux-act';
import { toastr } from 'react-redux-toastr';
import { url } from 'utils/url';
import Axios from 'axios';

const baseUrl = url;
export const WEB_TEMPLATE_FETCH = createAction('WEB_TEMPLATE_FETCH');
export const WEB_TEMPLATE_FETCH_DATA_SUCCESS = createAction(
  'WEB_TEMPLATE_FETCH_DATA_SUCCESS'
);
export const WEB_TEMPLATE_FETCH_DATA_FAIL = createAction(
  'WEB_TEMPLATE_FETCH_DATA_FAIL'
);

export const WEB_TEMPLATE_DELETE_INIT = createAction(
  'WEB_TEMPLATE_DELETE_INIT'
);
export const WEB_TEMPLATE_DELETE_SUCCESS = createAction(
  'WEB_TEMPLATE_DELETE_SUCCESS'
);
export const WEB_TEMPLATE_DELETE_FAIL = createAction(
  'WEB_TEMPLATE_DELETE_FAIL'
);

export const WEB_TEMPLATE_CLEAR_DATA = createAction('WEB_TEMPLATE_CLEAR_DATA');

export const WEB_TEMPLATE_CREATE_INIT = createAction(
  'WEB_TEMPLATE_CREATE_INIT'
);
export const WEB_TEMPLATE_CREATE_SUCCESS = createAction(
  'WEB_TEMPLATE_CREATE_SUCCESS'
);
export const WEB_TEMPLATE_CREATE_FAIL = createAction(
  'WEB_TEMPLATE_CREATE_FAIL'
);

export const WEB_TEMPLATE_MODIFY_INIT = createAction(
  'WEB_TEMPLATE_MODIFY_INIT'
);
export const WEB_TEMPLATE_MODIFY_SUCCESS = createAction(
  'WEB_TEMPLATE_MODIFY_SUCCESS'
);
export const WEB_TEMPLATE_MODIFY_FAIL = createAction(
  'WEB_TEMPLATE_MODIFY_FAIL'
);

export const WEB_TEMPLATE_CLEAN_UP = createAction('WEB_TEMPLATE_CLEAN_UP');

export const WEB_TEMPLATE_CLEAR_DATA_LOGOUT = createAction(
  'WEB_TEMPLATE_CLEAR_DATA_LOGOUT'
);
export const WEB_TEMPLATE_BULK = createAction('WEB_TEMPLATE_BULK');

export const SET_WEB_TEMPLATE = createAction('SET_WEB_TEMPLATE');

export const fetchWebTemplates = ({ siteId }) => {
  return async (dispatch, getState) => {
    dispatch(WEB_TEMPLATE_FETCH());
    let webTemplateData;
    try {
      webTemplateData = await Axios.get(
        `${baseUrl}/webTemplates/list/${siteId}`,
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem('accessToken')}`,
          },
        }
      );
    } catch (error) {
      let errorMessage;
      if (error.response) {
        errorMessage = error && error.response && error.response.data.message;
      }
      toastr.error('', errorMessage);
      return dispatch(WEB_TEMPLATE_FETCH_DATA_FAIL({ error }));
    }
    const WEB_TEMPLATE = { ...webTemplateData.data };
    return dispatch(
      WEB_TEMPLATE_FETCH_DATA_SUCCESS({
        list: getState().webTemplate.list,
        WEB_TEMPLATE,
      })
    );
  };
};

export const addWebTemplate = (formData) => async (dispatch) => {
  try {
    const res = await Axios.post(`${baseUrl}/webTemplates/create`, formData, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem('accessToken')}`,
      },
    });

    toastr.success('Success', 'Template created');

    return res.data.data;
  } catch (err) {
    console.log(err);
    toastr.error('Error', err.response?.data?.message || 'Failed');
    throw err;
  }
};

export const updateWebTemplate = (id, formData) => async (dispatch) => {
  try {
    const res = await Axios.put(
      `${baseUrl}/webTemplates/update/${id}`,
      formData,
      {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('accessToken')}`,
        },
      }
    );

    toastr.success('Success', 'Template updated');

    return res.data.data;
  } catch (err) {
    console.log(err);
    toastr.error('Error', err.response?.data?.message || 'Failed');
    throw err;
  }
};
